import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';

import './index.scss';

const b = b_.with('stock-landing-about');

interface Props {
  description: string;
}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

export const About: React.FC<Enhanced> = ({ t, description }) => (
  <div className="invest-landing-section">
    <h2 className="invest-landing-section__title">{t('About investment idea')}</h2>
    <div className="invest-landing__content">
      <div className="invest-landing-dropdown__row">
        <div className={b('description')}>{description}</div>
      </div>
    </div>
  </div>
);

export default enhance(About);
